const chains = [];
chains.push({ _operation: 'getUserSessionsByUserId', api: '/user/:userId/sessions', defaultData: [], httpVerb: 'get' });
chains.push({ _operation: 'removeUserSessionById', api: '/user/:userId/session/:objectId/remove', defaultData: null, httpVerb: 'put' });
export default chains;
